import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

const OverlaySelectLayerSeasons = ({
  extendedHeight,
  seasons,
  onSelect,
  selectedSeason
}) => {
  const classString = classNames({
    'form-control': true,
    'vra-layer-selector__select': true,
    'vra-layer-selector__select--extended': extendedHeight
  });
  const layerList = [];
  seasons.forEach( (layer) => {
    const layerClassString = classNames({
      'vra-layer-selector__option': true,
      'vra-layer-selector__option--selected': selectedSeason === layer
    });
    layerList.push(
      <div className={layerClassString} key={layer} onClick={ () => onSelect(layer) }>
        {layer}
      </div>
    );
  });

  return (
    <div data-test-id="map-season-selector" className={classString}>
      {layerList}
    </div>
  );
};

OverlaySelectLayerSeasons.propTypes = {
  extendedHeight: propTypes.bool,
  onSelect: propTypes.func.isRequired,
  seasons: propTypes.array.isRequired,
  selectedSeason: propTypes.string
};

export default OverlaySelectLayerSeasons;
